import React from "react"

import { SettingsWhatsapp } from "./SettingsWhatsapp.tsx"

export function NotificationPreferencesSection() {
  return (
    <div className="space-y-6">
      {/*/!* Email Notifications *!/*/}
      {/*<div className="flex items-start justify-between">*/}
      {/*  <div className="flex-1">*/}
      {/*    <Text className="font-medium block">Email Notifications</Text>*/}
      {/*    <Text className="text-xs text-gray-500">*/}
      {/*      Receive system updates and alerts via email*/}
      {/*    </Text>*/}
      {/*  </div>*/}
      {/*  <Switch />*/}
      {/*</div>*/}

      {/*/!* In-App Notifications *!/*/}
      {/*<div className="flex items-start justify-between">*/}
      {/*  <div className="flex-1">*/}
      {/*    <Text className="font-medium block">In-App Notifications</Text>*/}
      {/*    <Text className="text-xs text-gray-500">*/}
      {/*      Real-time alerts within the application*/}
      {/*    </Text>*/}
      {/*  </div>*/}
      {/*  <Switch />*/}
      {/*</div>*/}

      {/*/!* WhatsApp/SMS Alerts *!/*/}
      {/*<div className="flex items-start justify-between">*/}
      {/*  <div className="flex-1">*/}
      {/*    <div className="flex items-center gap-2">*/}
      {/*      <Text className="font-medium">WhatsApp/SMS Alerts</Text>*/}
      {/*      <span className="text-xs text-orange-600 bg-orange-50 px-2 py-0.5 rounded">*/}
      {/*        Premium Feature*/}
      {/*      </span>*/}
      {/*    </div>*/}
      {/*    <Text className="text-xs text-gray-500">*/}
      {/*      Critical updates via mobile messaging*/}
      {/*    </Text>*/}
      {/*  </div>*/}
      {/*  <Switch />*/}
      {/*</div>*/}

      {/*<Alert*/}
      {/*  message="Notification Frequency"*/}
      {/*  description="You'll receive a daily digest of non-urgent notifications at 8:00 AM"*/}
      {/*  type="info"*/}
      {/*  icon={<InfoCircleOutlined />}*/}
      {/*  showIcon*/}
      {/*/>*/}
      <SettingsWhatsapp />
    </div>
  )
}
